import { render, staticRenderFns } from "./queryQuotationRank.vue?vue&type=template&id=756da5c4&"
import script from "./queryQuotationRank.vue?vue&type=script&lang=js&"
export * from "./queryQuotationRank.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports